import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewPageStateModuleName } from '@/store/modules/modules'

export class ReviewPageStateViewModel {
  private store = useStore()

  isFirstOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ReviewPageStateModuleName}/isFirstOpendPage`]
  )
  entrySummaryExpandedList: ComputedRef<{ [entryId: string]: boolean }> = computed(
    () => this.store.getters[`${ReviewPageStateModuleName}/entrySummaryExpandedList`]
  )

  entrySelectedReviewIndexList: ComputedRef<{ [entryId: string]: number }> = computed(
    () => this.store.getters[`${ReviewPageStateModuleName}/entrySelectedReviewIndexList`]
  )

  setIsFirstOpendPage(flag: boolean): void {
    this.store.commit(`${ReviewPageStateModuleName}/setIsFirstOpendPage`, { flag })
  }

  setEntrySummaryExpandedList(list: { [entryId: string]: boolean }): void {
    this.store.commit(`${ReviewPageStateModuleName}/setEntrySummaryExpandedList`, { list })
  }

  setEntrySelectedReviewIndexList(list: { [entryId: string]: number }): void {
    this.store.commit(`${ReviewPageStateModuleName}/setEntrySelectedReviewIndexList`, { list })
  }

  setEntrySummaryExpandedFlag(entryId: string, flag: boolean): void {
    this.store.commit(`${ReviewPageStateModuleName}/setEntrySummaryExpandedFlag`, { entryId, flag })
  }

  setEntrySelectedReviewIndex(entryId: string, selectedReviewIndex: number): void {
    this.store.commit(`${ReviewPageStateModuleName}/setEntrySelectedReviewIndex`, {
      entryId,
      selectedReviewIndex
    })
  }
}
